<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Payment Receipt",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_data: moment(new Date()).format("DD-MM-YYYY"),
      id: atob(this.$route.params.id),
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("insurance", ["PaymentsinsrecieptRep", "InsuranceInvoiceStatus"]),
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPaymentsinsrecieptRepReprint: "insurance/fetchInsurancePaymentsReceiptReprint",
    }),
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
  },
  updated() {
    setTimeout(() => {
      window.print();
    }, 2000);
  },
  created() {
    this.FetchPaymentsinsrecieptRepReprint(this.id);
  },
};
</script>
<style scoped>
.print-font {
  font-family: "Lucida Console", "Courier New", monospace;
}
</style>
<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <Toasts
            :show-progress="true"
            :rtl="true"
            :max-messages="20"
            :time-out="3000"
            :closeable="false"
            :solid="true"
          ></Toasts>
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print Receipt</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white p-2">
          <div class="print-font">
            <center>
              <b-spinner
                v-if="InsuranceInvoiceStatus"
                class="m-0"
                variant="primary"
                role="status"
              ></b-spinner>
              <img
                v-else
                :src="
                  PaymentsinsrecieptRep.clinic_logo
                    ? PaymentsinsrecieptRep.clinic_logo
                    : '--'
                "
                alt="Logo"
                height="70"
              />
              <br />
              <strong>
                {{
                  PaymentsinsrecieptRep.clinic_name
                    ? PaymentsinsrecieptRep.clinic_name
                    : "---"
                }}</strong
              >
              <p>
                <span>
                  {{
                    PaymentsinsrecieptRep.clinic_location
                      ? PaymentsinsrecieptRep.clinic_location
                      : "---"
                  }}</span
                >
                <br />
                {{
                  PaymentsinsrecieptRep.clinic_contact
                    ? "+256" + PaymentsinsrecieptRep.clinic_contact
                    : "---"
                }}
                <br />
                {{
                  PaymentsinsrecieptRep.clinic_email
                    ? PaymentsinsrecieptRep.clinic_email
                    : "---"
                }}
              </p>
              <h6>INSURANCE PAYMENT RECEIPT REPRINT</h6>
            </center>
            <hr style="border-style: dashed; width: 97%" />
            <center>
              <table width="100%">
                <tr>
                  <td><b>Reprint date</b></td>
                  <td>{{ current_data }}</td>
                </tr>
                <tr>
                  <td><b>TXT Date</b></td>
                  <td>
                    {{
                      PaymentsinsrecieptRep.txt_date
                        ? PaymentsinsrecieptRep.txt_date
                        : "---"
                    }}
                  </td>
                </tr>
                <tr>
                  <td><b>Name</b></td>
                  <td>
                    {{
                      PaymentsinsrecieptRep.insurance_name
                        ? PaymentsinsrecieptRep.insurance_name
                        : "---"
                    }}
                  </td>
                </tr>
                <tr>
                  <td><b>Contact</b></td>
                  <td>
                    {{
                      PaymentsinsrecieptRep.insurance_contact
                        ? PaymentsinsrecieptRep.insurance_contact
                        : "---"
                    }}
                  </td>
                </tr>
                <tr>
                  <td><b>Invoice</b></td>
                  <td>
                    {{
                      PaymentsinsrecieptRep.invoice_no
                        ? PaymentsinsrecieptRep.invoice_no
                        : "---"
                    }}
                  </td>
                </tr>

                <tr>
                  <td><b>Reciept</b></td>
                  <td>
                    {{
                      PaymentsinsrecieptRep.reciept_no
                        ? PaymentsinsrecieptRep.reciept_no
                        : "--"
                    }}
                  </td>
                </tr>
              </table>
            </center>
            <hr />

            <br />
            <div style="width: 100%">
              <b
                >Recieved:{{
                  this.thousandSeprator(
                    PaymentsinsrecieptRep.recieved ? PaymentsinsrecieptRep.recieved : "--"
                  )
                }}/=</b
              >
              <p>
                <b>Total:</b>
                {{
                  this.thousandSeprator(
                    PaymentsinsrecieptRep.total ? PaymentsinsrecieptRep.total : "0"
                  )
                }}/=
                <br />
                <b>Paid:</b>
                {{
                  this.thousandSeprator(
                    PaymentsinsrecieptRep.paid ? PaymentsinsrecieptRep.paid : "0"
                  )
                }}/=

                <br />
                <b>Balance:</b>
                {{
                  this.thousandSeprator(
                    PaymentsinsrecieptRep.balance ? PaymentsinsrecieptRep.balance : "0"
                  )
                }}/=
              </p>
            </div>
            <center>
              <hr style="border-style: dashed; width: 97%" />
              <p>
                Signature ..........................................
                <br />Thank you for trusting
                <strong>
                  {{
                    PaymentsinsrecieptRep.clinic_name
                      ? PaymentsinsrecieptRep.clinic_name
                      : "---"
                  }}</strong
                >
                <br />For more inquiries call
                <strong>{{
                  PaymentsinsrecieptRep.clinic_contact
                    ? PaymentsinsrecieptRep.clinic_contact
                    : "---"
                }}</strong>
              </p>
              <p>
                Receipt Printed by
                {{
                  PaymentsinsrecieptRep.printuser ? PaymentsinsrecieptRep.printuser : "--"
                }}
                via Clinic Plus Hospital Software
              </p>
            </center>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
